const lang = {
    en: {
        search: 'Search',
        gptSearchPlaceHolder: 'What would you like to watch today?'
    },
    hindi: {
        search: 'ढूँढ',
        gptSearchPlaceHolder: 'आप आज क्या देखना चाहेंगे?'
    },
    spanish: {
        search: 'Buscar',
        gptSearchPlaceHolder: '¿Qué te gustaría ver hoy?'
    }
}
export default lang;